import React, { FC, ReactNode, useContext, useState } from 'react'
import s from './AdvDetailedPopup.module.sass'
import { useClientResponsive } from '@shared/lib/hooks/useClientResponsive'
import { ErrorBoundary } from '@shared/lib/components/ErrorBoundary'
import { Popup } from '@shared/ui/Overlays/Popup'
import { PopupContent } from '@shared/ui/Overlays/Popup/ui/PopupContent'
import { AdvDetailedContext } from '@features/Common/AdvDetailed/Context'
import { Text } from '@shared/ui/Typography/Text'
import { Button } from '@shared/ui/Actions/Button'
import copyTextToClipboard from '@pages/OwnerPersonalPage/ui/pages/OwnerRestCardPage/copyTextToClipboard'
import { useAppDispatch } from '@app/model/store'
import { addTemporaryNotice } from '@widgets/Common/Notices'

interface Props {
  description: string
  token: string
  className?: string
  handleClose?: () => void
}

const AdvDetailedPopup: FC<Props & React.ButtonHTMLAttributes<any>> = ({
  description,
  token,
  className = '',
  handleClose,
  ...props
}) => {
  // @ts-ignore
  const [context, setContext] = useContext(AdvDetailedContext)
  const [tokenCopied, setTokenCopied] = useState(false)
  const { isMobile } = useClientResponsive()
  const dispatch = useAppDispatch()
  const onOpenChangePopup = (value) => {
    if (!value) {
      handleCloseInner()
      setTokenCopied(false)
    }
  }

  const handleCloseInner = () => {
    handleClose ? handleClose() : setContext((prev) => ({ ...prev, opened: false }))
  }

  const handleCopyToken = () => {
    if (tokenCopied) return
    else {
      copyTextToClipboard(token, () => {
        setTokenCopied(true)
        dispatch(addTemporaryNotice({ markup: 'Токен скопирован' }))
      })
    }
  }

  return (
    <ErrorBoundary>
      <Popup
        open={context.opened}
        offset={6}
        placement={'left-start'}
        autoFocus={false}
        triggerRef={context.floatingRelative}
        onOpenChange={onOpenChangePopup}>
        <PopupContent className={`${s.popup} ${className}`}>
          <Text className={s.description} sizes={'S'}>
            {description}
          </Text>
          {!!token && (
            <Button
              className={s.button}
              data-is-copied={tokenCopied}
              sizes={'M'}
              mode={'white-shadow'}
              onClick={handleCopyToken}>
              {tokenCopied ? 'Токен скопирован' : 'Скопировать токен'}
            </Button>
          )}
        </PopupContent>
      </Popup>
    </ErrorBoundary>
  )
}

export default AdvDetailedPopup
